import t from"date-fns/parseISO";import e from"date-fns/format";import o from"../getDateFnsLocale/getDateFnsLocale.js";const a=(a,r)=>{const s=o(r),f=t(a);return e(f,"MMMM d, yyyy",{locale:s})};export{a as default};
//# sourceMappingURL=getLocaleFormattedDate.js.map
